import { render, staticRenderFns } from "./SelectComplaintViews.vue?vue&type=template&id=a95ed2c4&scoped=true&"
import script from "./SelectComplaintViews.vue?vue&type=script&lang=js&"
export * from "./SelectComplaintViews.vue?vue&type=script&lang=js&"
import style0 from "./SelectComplaintViews.vue?vue&type=style&index=0&id=a95ed2c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ed2c4",
  null
  
)

export default component.exports